<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
/**
 * Advanced table component
 */
export default {
  page: {
    title: "Budget",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
  },
  data() {
    return {
      title: "Revenues",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Budget",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "name",
          label: "Category",
          sortable: true,
        },
        {
          key: "amount",
          label: "Amount",
          sortable: true,
        },
        {
          key: "date",
          label: "Date Received",
          sortable: true,
        },
        {
          key: "mode",
          label: "Payment Mode",
          sortable: true,
        },
        {
          key: "from",
          label: "Received From",
          sortable: true,
        },
        {
          key: "description",
          label: "Description",
          sortable: true,
        },
        {
          key: "user",
          label: "Added By",
          sortable: true,
        },
        {
          key: "date",
          label: "Added On",
          sortable: true,
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      data: {
        category: "",
        date: moment(new Date()).format("YYYY-MM-DD"),
        from: "",
        mode: "",
        description: "",
        amount: "",
      },
      deletedata: {
        name: "",
        id: "",
      },
      editdata: {
        category: "",
        from: "",
        mode: "",
        description: "",
        date: "",
        amount: "",
        id: "",
      },
      amountError: "",
      modeError: "",
      categoryError: "",
      modal: "",
    };
  },
  computed: {
    ...mapGetters("revenues", ["Categories", "Revenues", "SaveStatus"]),
    ...mapGetters("modes", ["Modes"]),
    ...mapGetters("auth", ["getCurrentUser"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.Revenues ? this.Revenues.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Revenues ? this.Revenues.length : 1;
  },
  methods: {
    ...mapActions({
      FetchCategories: "revenues/fetchRevCategories",
      FetchRevenues: "revenues/fetchRevenues",
      FetchModes: "modes/fetchModes",
      AddRevenue: "revenues/addRevenue",
      EditRevenue: "revenues/editRevenue",
      DeleteRevenue: "revenues/deleteRevenue",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.Revenues ? this.Revenues.length : 1;
      this.currentPage = 1;
    },

    // COMMA SEPERTOR FUNCTION
    thousandSeperater(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    addCommas() {
      this.data.amount = this.thousandSeperater(this.data.amount);
    },
    addCommasEdit() {
      this.editdata.amount = this.thousandSeperater(this.editdata.amount);
    },
    resetError() {
      this.amountError = "";
      this.modeError = "";
      this.categoryError = "";
    },

    resetAddModal() {
      this.data.category = "";
      this.data.amount = "";
      this.data.description = "";
      this.data.from = "";
      this.resetError();
    },
    resetEditModal() {
      this.editdata.category = "";
      this.editdata.amount = "";
      this.editdata.description = "";
      this.editdata.date = "";
      this.editdata.from = "";
      this.editdata.mode = "";
      this.resetError();
    },
    resetDeleteModal() {
      this.deletedata.name = "";
      this.deletedata.id = "";
    },

    addRevenue(modal) {
      if (this.data.amount == "") {
        this.amountError = "Amount Received can't be empty";
        return;
      } else {
        this.amountError = "";
      }
      if (this.data.mode == "") {
        this.modeError = "Payment Method field can't be empty";
        return;
      } else {
        this.modeError = "";
      }
      if (this.data.category == "") {
        this.categoryError = "Revenue Category field can't be empty'";
        return;
      } else {
        this.categoryError = "";
      }
      this.modal = modal;
      this.AddRevenue(this.data);
      this.resetError();
      this.resetAddModal();
      this.closeModal(this.modal);
    },
    showEditModal(values) {
      this.editdata.id = values.item.id;
      this.editdata.amount = values.item.amount;
      this.editdata.category = values.item.category;
      this.editdata.from = values.item.from;
      this.editdata.description = values.item.description;
      this.editdata.mode = values.item.modeId;
      this.editdata.date = values.item.date;
    },
    showDeleteModal(values) {
      this.deletedata.id = values.item.id;
      this.deletedata.name = values.item.amount;
    },
    deleteRevenue(modal) {
      this.modal = modal;
      this.DeleteRevenue(this.deletedata);
      this.closeModal(modal);
    },
    editRevenue(modal) {
      if (this.editdata.amount == "") {
        this.amountError = "Amount Received can't be empty";
        return;
      } else {
        this.amountError = "";
      }
      if (this.editdata.mode == "") {
        this.modeError = "Payment Method field can't be empty";
        return;
      } else {
        this.modeError = "";
      }
      if (this.editdata.category == "") {
        this.categoryError = "Revenue Category field can't be empty'";
        return;
      } else {
        this.categoryError = "";
      }
      this.modal = modal;
      this.EditRevenue(this.editdata);
      this.resetError();
      this.closeModal(this.modal);
    },

    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchCategories();
    this.FetchRevenues();
    this.FetchModes();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_revenue_acc')
        )
      "
    >
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h3 class="card-title text-primary">List of All Revenues</h3>
              </div>
              <div class="col-md-3">
                <button
                  v-b-modal.add-modal
                  class="btn btn-sm btn-primary float-end"
                  v-if="
                    getCurrentUser.permissions.find((item) =>
                      item.permission.includes('add_revenue_acc')
                    )
                  "
                >
                  <i class="fa fa-plus"></i> Add New
                </button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="Revenues ? Revenues : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(actions)="data">
                  <b-button-group>
                    <b-button
                      size="sm"
                      variant="primary"
                      v-b-modal.edit-modal
                      @click="showEditModal(data)"
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('edit_revenue_acc')
                        )
                      "
                      ><i class="fa fa-edit"></i> Edit</b-button
                    >
                    <b-button
                      size="sm"
                      variant="danger"
                      v-b-modal.delete-modal
                      @click="showDeleteModal(data)"
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('delete_revenue_acc')
                        )
                      "
                      ><i class="fa fa-trash"></i> Delete</b-button
                    >
                  </b-button-group>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- modal starts -->
      <b-modal
        id="add-modal"
        size="lg"
        hide-footer
        @hidden="resetAddModal()"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('add_revenue_acc')
          )
        "
      >
        <template #modal-title> Record New Revenue </template>
        <div class="row">
          <div class="form-group mb-3 col-md-6">
            <label>Category <span class="required">*</span></label>
            <div class="input-group">
              <model-list-select
                required
                :list="Categories ? Categories : []"
                v-model="data.category"
                option-value="id"
                option-text="name"
                class="mb-2"
                @input="resetError()"
                placeholder="Select Revenue Category"
              >
              </model-list-select>
            </div>
            <div class="text-danger" v-if="categoryError">
              <em>{{ categoryError }}</em>
            </div>
          </div>
          <div class="form-group mb-3 col-md-6">
            <label>Amount Received <span class="required">*</span></label>
            <div class="input-group">
              <input
                type="text"
                placeholder="Enter Amount"
                class="form-control"
                @input="resetError(), addCommas()"
                v-model="data.amount"
              />
            </div>
            <div class="text-danger" v-if="amountError">
              <em>{{ amountError }}</em>
            </div>
          </div>
          <div class="form-group mb-3 col-md-6">
            <label>Date Received</label>
            <div class="input-group">
              <input type="date" class="form-control" v-model="data.date" />
            </div>
          </div>
          <div class="form-group mb-3 col-md-6">
            <label>Receiving Mode <span class="required">*</span></label>
            <div class="input-group">
              <model-list-select
                :list="Modes ? Modes : []"
                v-model="data.mode"
                option-value="id"
                option-text="name1"
                class="mb-2"
                @input="resetError()"
                placeholder="Select Payment Method"
              >
              </model-list-select>
            </div>
            <div class="text-danger" v-if="modeError">
              <em>{{ modeError }}</em>
            </div>
          </div>
          <div class="form-group mb-3 col-md-6">
            <label>Received From</label>
            <div class="input-group">
              <input
                type="text"
                placeholder="Enter Source"
                class="form-control"
                v-model="data.from"
              />
            </div>
          </div>
          <div class="form-group mb-3 col-md-6">
            <label>Description</label>
            <div class="input-group">
              <textarea
                class="form-control"
                cols="30"
                rows="3"
                placeholder="Brief Description"
                v-model="data.description"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-sm btn-outline-danger"
            data-dismiss="modal"
            @click="closeModal('add-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-sm btn-outline-primary"
            @click="addRevenue('add-modal')"
          >
            <i class="fa fa-check"></i>
            Submit
            <b-spinner
              v-if="SaveStatus"
              variant="light"
              small
              label="Spinning"
            ></b-spinner>
          </button>
        </div>
      </b-modal>
      <!-- modal ends -->
      <!-- edit modal starts -->
      <b-modal
        id="edit-modal"
        hide-footer
        @hidden="resetEditModal()"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('edit_revenue_acc')
          )
        "
      >
        <template #modal-title>
          Edit Revenue of Amount {{ editdata.amount }}</template
        >
        <div class="form-group mb-3">
          <label>Category <span class="required">*</span></label>
          <div class="input-group">
            <model-list-select
              required
              :list="Categories ? Categories : []"
              v-model="editdata.category"
              option-value="id"
              option-text="name"
              class="mb-2"
              @input="resetError()"
              placeholder="Select Revenue Category"
            >
            </model-list-select>
          </div>
          <div class="text-danger" v-if="categoryError">
            <em>{{ categoryError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Amount Received <span class="required">*</span></label>
          <div class="input-group">
            <input
              type="text"
              placeholder="Enter Amount"
              class="form-control"
              @input="resetError(), addCommasEdit()"
              v-model="editdata.amount"
            />
          </div>
          <div class="text-danger" v-if="amountError">
            <em>{{ amountError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Date Received</label>
          <div class="input-group">
            <input type="date" class="form-control" v-model="editdata.date" />
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Receiving Mode <span class="required">*</span></label>
          <div class="input-group">
            <model-list-select
              :list="Modes ? Modes : []"
              v-model="editdata.mode"
              option-value="id"
              option-text="name1"
              class="mb-2"
              @input="resetError()"
              placeholder="Select Payment Method"
            >
            </model-list-select>
          </div>
          <div class="text-danger" v-if="modeError">
            <em>{{ modeError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Received From</label>
          <div class="input-group">
            <input
              type="text"
              placeholder="Enter Source"
              class="form-control"
              v-model="editdata.from"
            />
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Description</label>
          <div class="input-group">
            <textarea
              class="form-control"
              cols="30"
              rows="3"
              placeholder="Brief Description"
              v-model="editdata.description"
            ></textarea>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-danger"
            data-dismiss="modal"
            @click="closeModal('edit-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-outline-primary"
            @click="editRevenue('edit-modal')"
          >
            <i class="fa fa-check"></i>
            Save Changes</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Saving"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->

      <!-- modal delete fyear starts -->
      <b-modal
        id="delete-modal"
        hide-footer
        @hidden="resetDeleteModal"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('delete_revenue_acc')
          )
        "
      >
        <template #modal-title>
          <h4 class="text-danger">
            Delete Revenue Of {{ deletedata.name }}
          </h4></template
        >
        <div class="form-group mb-3">
          <div class="input-group">
            <h5>
              Do you want to delete Revenue Of {{ deletedata.name }}? Click
              Proceed Button to delete.
            </h5>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-secondary"
            data-dismiss="modal"
            @click="closeModal('delete-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-outline-danger"
            @click="deleteRevenue('delete-modal')"
          >
            <i class="fa fa-trash"></i> Confirm</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Deleting"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style scoped>
.required {
  color: red;
}
</style>
